export default [11720, 31995, 30765, 37076, 25962, 45292, 35978, 27256, 10503, 29258];
